import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AnimationBehavior } from '@freelancer/directives';
import { PictureLoadMethod } from '@freelancer/ui/picture';
import { SectionArticleColor } from './section-article.types';

@Component({
  standalone: false,
  selector: 'fl-section-article-entry',
  template: `
    <div
      class="mb-mid tablet:mb-none"
      [flAnimateOnScroll]="animateOnScroll"
      [flAnimateOnScrollBehavior]="animateOnScrollBehavior"
    >
      @if (pictureSrc) {
        <div class="mb-xxsmall">
          <fl-picture
            class="Illustration"
            [src]="pictureSrc"
            [alt]="pictureAlt"
            [loadMethod]="PictureLoadMethod.LAZY"
            [width]="pictureExplicitWidth"
            [height]="pictureExplicitHeight"
          ></fl-picture>
        </div>
      }
      <h3
        class="text-body-16 desktop:text-body-20 mb-xxsmall"
        [class.text-foreground]="color === SectionArticleColor.DARK"
        [class.text-light]="!(color === SectionArticleColor.DARK)"
      >
        <ng-content select="fl-section-article-entry-heading"></ng-content>
      </h3>
      <div
        class="text-body-16 desktop:text-body-16 font-normal {{
          color === SectionArticleColor.DARK ? 'text-foreground' : 'text-light'
        }}"
      >
        <ng-content select="fl-section-article-entry-detail"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./section-article-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionArticleEntryComponent {
  SectionArticleColor = SectionArticleColor;
  PictureLoadMethod = PictureLoadMethod;

  @Input() color: SectionArticleColor = SectionArticleColor.DARK;
  @Input() pictureSrc: string;
  @Input() pictureExplicitWidth?: number;
  @Input() pictureExplicitHeight?: number;
  @Input() pictureAlt: string;
  @Input() animateOnScroll = false;
  @Input() animateOnScrollBehavior: AnimationBehavior =
    AnimationBehavior.FADE_FROM_BOTTOM;
}
